import React from 'react'
import PropTypes from 'prop-types'

const ButtonWithLoader = (props) => {
    const isExternal = () => {
        return /^https?:\/\//.test(props.href)
    }

    return (
        <a
            href={props.href ? props.href : '#'}
            target={isExternal() ? '_blank' : ''}
            className={`btn btn-custom btn-with-loader ${props.isLoading ? 'show-loader' : ''} ${props.isLoaded ? 'show-loaded' : ''} ${props.className ? props.className : ''}`}
            onClick={props.action}
        >
            <span>{props.title}</span>
        </a>
    )
}

ButtonWithLoader.propTypes = {
    title: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoaded: PropTypes.bool,
    href: PropTypes.string,
    className: PropTypes.string,
    action: PropTypes.func
}

export default ButtonWithLoader



// WEBPACK FOOTER //
// ./resources/js/elements/ButtonWithLoader.js